module.exports = __webpack_public_path__ + "static/DWI20_Reg_1700x1200_Nahe-07d0680e9460af7ca4a81333d4edd793.jpeg";